import type { Tier } from '#shared/types/tiers'
import { TIER_DEPOSITS, TIER_POLICY_REQUIREMENTS } from './foundation'

export const TIERS: Readonly<Tier[]> = [
  { id: 'trial', name: 'Trial', type: 'Property Insurance', price: 0 },
  { id: 'bronze', name: 'Bronze', type: 'Property Insurance', price: 100 },
  { id: 'silver', name: 'Silver', type: 'Property Insurance', price: 500 },
  { id: 'gold', name: 'Gold', type: 'Property Insurance', price: 1000 },
] as const

export const TIER_DEPOSITS_BY_TIER: Record<Tier['id'], number> = TIER_DEPOSITS

export const TIER_POLICY_REQUIREMENTS_BY_TIER: Record<Tier['id'], readonly string[]> = TIER_POLICY_REQUIREMENTS

export const MEMBERSHIP_ACTION = {
  UPGRADE: 'upgrade',
  DOWNGRADE: 'downgrade',
  UPDATE_POI: 'update-poi',
  END_MEMBERSHIP: 'end-membership',
  REAPPLY: 'reapply',
  DEPOSIT: 'deposit',
  WITHDRAW: 'withdraw',
} as const

export type MembershipAction = typeof MEMBERSHIP_ACTION[keyof typeof MEMBERSHIP_ACTION]

export const MEMBERSHIP_PROCESS_STEP = {
  SELECT: 'select',
  CONFIGURE: 'configure',
  PROCESS: 'process',
} as const

export type MembershipProcessStep = typeof MEMBERSHIP_PROCESS_STEP[keyof typeof MEMBERSHIP_PROCESS_STEP]

export const MAX_POLICY_FILE_SIZE_BYTES = 20 * 1024 * 1024

export const ALLOWED_POLICY_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
] as const

export const POLICY_MINIMUM_DAYS_REMAINING = 30

export const DEFAULT_TIER = 'bronze' as const satisfies Tier['id']
